'use strict';/* global define */define('modules/graphs/services/timeline-axes/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["d3"];
function factory(d3){// jshint validthis:true
// jshint latedef:false
return{timelineXAxis:timelineXAxis};// ---
/**
     * Decorate the d3 x axis to bring in custom styling
     * for axis ticks
     *
     * @return {Function} render function to be
     *                    attached to d3 elements via `call`
     */function timelineXAxis(){var axis=d3.svg.axis();var newAxis=function newAxis(g){// render d3 axes default behavior
axis(g);// highlight the year selection
g.selectAll('.tick').filter(function(d){return d.getDate()===1&&d.getMonth()===0;}).attr('class',function(d,el){return'tick year';});};// copy over the things d3 axis
// brings into this function
Object.keys(axis).reduce(function(fn,key){fn[key]=function(){axis[key].apply(null,arguments);return fn;};return fn;},newAxis);return newAxis;}}module.exports=factory;});
